import React, { useState } from "react";
import classNames from "classnames";

const HelpItem = ({item}) => {
  const [collapsed, setCollapse] = useState(null)
  const [chevron, setChevron] = useState(null)

  const style = {
    maxHeight: (collapsed ? '500px' : '0px')
  }

  const collapsoid = () => {
    setCollapse(!collapsed)
  }

  const setActive = () => {
    setChevron( collapsed ? null : "rotate")
    collapsoid()
  }

  const chevronClass = () => {
    return classNames(
      "fa fa-chevron-right",
      chevron
    )
  }

  return(
    <div className="help-item" >
      <div className="title" onClick={setActive}>
        <i className={chevronClass()}></i>
        {item.title}
      </div>
      <div style={style} className="body" dangerouslySetInnerHTML={{__html: item.body}}></div>
    </div>
  )
}

export default HelpItem
